import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function updateMentorImageAPI(authToken: string, mentorId: string, payload: any): Observable<any> {
    return educatAPI.put(
        `mentors/${mentorId}/update_mentor_image`,
        payload,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
